// extracted by mini-css-extract-plugin
var _1 = "PSHx8";
var _2 = "dBnE9 elide";
var _3 = "DpUf4";
var _4 = "OZcJn";
var _5 = "dpcQi";
var _6 = "nGbN7";
var _7 = "Kt5ek";
var _8 = "MC2iv";
var _9 = "xUTQc";
var _a = "Xu0OI";
var _b = "lAxhW";
var _c = "DA8nN";
var _d = "yxXkO";
var _e = "lWxuq";
var _f = "FZnst";
export { _1 as "base", _2 as "cell", _3 as "column", _4 as "columns", _5 as "corners", _6 as "cornersRight", _7 as "footers", _8 as "grid-data", _9 as "headers", _a as "main", _b as "resizer", _c as "sticky", _d as "theme-dark", _e as "theme-light", _f as "top" }
